import styled from "styled-components"
import { Scroll } from "styles/GlobalCss"

export const CreateBatteryStyles = styled.div`
display: grid;
grid-template-columns: auto 300px;
column-gap: 10px;
height: 100%;
flex-grow: 1;
overflow: auto;
`

export const WrapAssessments = styled.div`
display: flex;
flex-direction: column;
row-gap: 8px;
height: 100%;
overflow: auto;
${Scroll};
`

export const WrapFormPanel = styled.div`
height: 100%;
overflow: auto;
${Scroll};
`
